import { SET_DRAWER, TOGGLE_DRAWER } from 'store/actions/drawer.action'

interface IState {
    open: boolean
}

const initialState: IState = {
    open: true,
}

export default function DrawerReducer(
    state: IState = initialState,
    action: any,
): IState {
    switch (action.type) {
        case TOGGLE_DRAWER: {
            return {
                open: !state.open,
            }
        }
        case SET_DRAWER: {
            return {
                open: action.payload,
            }
        }
        default:
            return state
    }
}
